import { Stack, Typography, useTheme } from "@mui/material";
import { FileText } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const PaperworkInfoNote: FC = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack direction="row" gap={1.2} px={2} py={1.6} mt={1.6}>
			<FileText
				size={16}
				color={theme.palette.grey[300]}
				style={{ flexShrink: 0, marginTop: 2 }}
			/>
			<Typography variant="hint" lineHeight={1.625}>
				{t(Resources.Paperwork.infoNote)}
			</Typography>
		</Stack>
	);
};
